// extracted by mini-css-extract-plugin
module.exports = {"previewLabel":"dNYzpKfuB8pfh4sAIjBP5","previewStat":"_3tPgnY0IGJf0lzsVjf0dk-","cta":"_18OsSLgJjnV48wqkl8i4il"};